export class AddSavedSearchActivityRequest {
    constructor(
        public readonly savedSearchId: number,
        public readonly listingsReturned: number,
        public readonly isNew: boolean,
        public readonly listingCategory: string,
        public readonly createdId: number,
        public readonly runById: number,
    ) { }
}